/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0 1.5c6.6274 0 12-5.3726 12-12S18.6274 0 12 0 0 5.3726 0 12s5.3726 12 12 12ZM6.75 7c0-.6904.5596-1.25 1.25-1.25a.75.75 0 0 0 0-1.5C6.4812 4.25 5.25 5.4812 5.25 7v3c0 .6904-.5596 1.25-1.25 1.25a.75.75 0 0 0 0 1.5c.6904 0 1.25.5596 1.25 1.25v3c0 1.5188 1.2312 2.75 2.75 2.75a.75.75 0 0 0 0-1.5c-.6904 0-1.25-.5596-1.25-1.25v-3c0-.788-.3315-1.4986-.8625-2 .531-.5014.8625-1.212.8625-2V7Zm10.5 10c0 .6904-.5596 1.25-1.25 1.25a.75.75 0 0 0 0 1.5c1.5188 0 2.75-1.2312 2.75-2.75v-3c0-.6904.5596-1.25 1.25-1.25a.75.75 0 0 0 0-1.5c-.6904 0-1.25-.5596-1.25-1.25V7c0-1.5188-1.2312-2.75-2.75-2.75a.75.75 0 0 0 0 1.5c.6904 0 1.25.5596 1.25 1.25v3c0 .788.3314 1.4986.8625 2-.5311.5014-.8625 1.212-.8625 2v3ZM9 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    clipRule="evenodd"
  />,
  'Swagger'
);
